import { TooltipContext } from "@progress/kendo-react-charts";

export const ScatterChartTooltip = (
  context: TooltipContext,
  valueFormatter: (v?: number) => string,
  currencyFormatter: (v?: number) => string,
  getItemValue: (v?: string) => number
) => {
  return (
    <div>
      <h6 style={{ color: "var(--tooltip-color)" }}>
        {context.point.dataItem.category}
      </h6>
      <div>Period Return: {valueFormatter(context.point.dataItem.yField)}</div>
      <div>Volatility : {valueFormatter(context.point.dataItem.xField)}</div>
      <div>
        Current Value :
        {getItemValue(context.point.dataItem.category as string)
          ? " " +
            currencyFormatter?.(
              getItemValue(context.point.dataItem.category as string)
            )
          : " n/a"}
      </div>
    </div>
  );
};
